import axios from 'axios';
import * as endpoints from './const';

import * as pbi from 'powerbi-client';

const embedConfig = apiConf => {
  const biConf = apiConf;
  const defConfig = {
    tokenType: pbi.models.TokenType.Embed,
    accessToken: biConf.embedtoken.token,
  };

  const finConf = Object.assign({}, defConfig, biConf);
  return finConf;
};

class PowerBIApi {
  static getRawConfig(url) {
    const fullurl = url.replace(/^\/?api/i, endpoints.getAPIRoot());
    return axios
      .get(fullurl)
      .then(response => response.data)
      .then(data => embedConfig(data.data))
      .catch(error => {
        throw error;
      });
  }
  static getDashboardEmbedConfig(dashboardId) {
    return axios
      .get(`${endpoints.API_ROOT}pb/dashboard/${dashboardId}`)
      .then(response => response.data)
      .then(data => embedConfig(data.data))
      .catch(error => {
        throw error;
      });
  }
  static getTileEmbedConfig(dashboardId, tileId) {
    return axios
      .get(`${endpoints.API_ROOT}pb/dashboard/${dashboardId}/tile/${tileId}`)
      .then(response => response.data)
      .then(data => embedConfig(data.data))
      .catch(error => {
        throw error;
      });
  }

  static getReportEmbedConfig(country, companyCode, reportId, businessEntity) {
    return axios
      .get(
        `${
        endpoints.API_ROOT
        }pb/report/${reportId}?countryCode=${encodeURIComponent(
          country
        )}&companyCode=${encodeURIComponent(companyCode)}`
      )
      .then(response => response.data)
      .then(data => {
        if (!data.success) {
          throw [data.errors, country, companyCode, reportId];
        }
        country = country ? country.toUpperCase() : '';
        businessEntity = businessEntity ? businessEntity.toUpperCase() : '';
        data.data.embedUrl = `${data.data.embedUrl}&BusinessEntity=${businessEntity}&Country=${country}`;
        return embedConfig(data.data);
      })
      .catch(error => {
        throw error;
      });
  }
}

export default PowerBIApi;



// WEBPACK FOOTER //
// ./src/api/PowerBIApi.js